export default __webpack_public_path__ + "static/unswLogo-9bce2ff209c0594ad784b01fd018b41d.jpeg";